const secondary = {
    social_bind_with: 'Вже маєте обліковий запис? Увійдіть, щоб зв’язати {{methods, list(type: disjunction;)}} з вашою соціальною ідентифікацією.',
};
export default Object.freeze(secondary);
